<template>
  <div class="min-h-20 mt-2 flex rounded-lg overflow-hidden">
    <div
      class="w-18 flex items-center justify-center text-white"
      :class="iconAreaClassByType[props.type]"
    >
      <Icon :size="IconSize.LG" :icon="iconComponentByType[props.type]" />
    </div>
    <div
      class="flex-1 flex justify-between items-center p-4 bg-white font-semibold"
      :class="contentAreaClassByType[props.type]"
    >
      {{ props.notification.title }}
      <IconButton
        :icon-name="IconName.CLOSE"
        label="Close"
        :size="ButtonSize.XS"
        :variant="ButtonVariant.TEXT"
        :color="ButtonColor.SECONDARY"
        @click="emit('close')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue';
import { NotificationType } from './notification.constants';
import { Icon, IconSize } from '@/components/base/icon';
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconName,
} from '@exfluential/ui';
import SuccessSvg from '@/assets/icons/success.svg?component';
import InfoSvg from '@/assets/icons/info.svg?component';
import ErrorSvg from '@/assets/icons/error.svg?component';

type Props = {
  type: NotificationType;
  notification: Record<string, unknown>;
};
const props = defineProps<Props>();
const emit = defineEmits<{
  close: [];
}>();

const iconComponentByType: Record<NotificationType, Component> = {
  [NotificationType.SUCCESS]: SuccessSvg,
  [NotificationType.INFO]: InfoSvg,
  [NotificationType.ERROR]: ErrorSvg,
};

const iconAreaClassByType: Record<NotificationType, string> = {
  [NotificationType.SUCCESS]: 'bg-green',
  [NotificationType.INFO]: 'bg-primary',
  [NotificationType.ERROR]: 'bg-red',
};

const contentAreaClassByType: Record<NotificationType, string> = {
  [NotificationType.SUCCESS]: 'text-green',
  [NotificationType.INFO]: 'text-primary',
  [NotificationType.ERROR]: 'text-red',
};
</script>
